import { memo } from 'react';

import { isNonNullish } from 'remeda';
import useSWR from 'swr';

import { Select } from '../Select';

import { SELECT_TOURNAMENT_DEFAULT_FILTER } from './constants';
import { tournamentsToOptions } from './utils';

import { tournamentsService } from 'v2/api/tournamentsService';
import { DEFAULT_FIRST_PAGE, DEFAULT_PAGE_SIZE } from 'v2/constants';
import { TournamentFilter } from 'v2/types/TournamentModel';

interface TournamentSelectProps {
  value: string;
  onChange: (tournamentId: string) => void;
  filter?: TournamentFilter;
}

export const TournamentSelect = memo<TournamentSelectProps>(
  ({ value, onChange, filter = SELECT_TOURNAMENT_DEFAULT_FILTER }) => {
    const { data } = useSWR(
      ['getTournaments', DEFAULT_FIRST_PAGE, DEFAULT_PAGE_SIZE, filter],
      tournamentsService.getTournaments
    );

    const handleChange = (tournamentId: string) => {
      onChange(tournamentId);
    };

    return (
      isNonNullish(data) && (
        <Select value={value} options={tournamentsToOptions(data.result)} label="Tournament" onChange={handleChange} />
      )
    );
  }
);

TournamentSelect.displayName = 'TournamentSelect';
